import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=7c2ebd93&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./homePc.scss?vue&type=style&index=0&id=7c2ebd93&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2ebd93",
  null
  
)

export default component.exports